import React from 'react';
import styled from 'styled-components';

const Text = styled.div`
	color: var(--text-color) !important;
	font-family: ${({ theme }) => theme.fontFamily.primary};
	font-size: 0.875rem;
	font-weight: ${({ theme }) => theme.fontWeight.black};
	line-height: 1.063rem;
	transition: color 0.3s;
`;

const TextDate = ({ className, children }) => {
	return <Text className={className}>{children}</Text>;
};

export default TextDate;
